export const DEFAULT_CLASS_HIDDEN_ON_EXPORT = 'hidden-on-export-html-as-image-f8a4d9f7-25e3-4cb0-89b1-7b943b14d7a1';
